// askSmart-ui/src/pages/TOSP/TospChromeContext.tsx
import { createContext, useContext } from "react";

// Lets a tab take over the page. When a section drills into a single record —
// a budget being worked on — the module's tab row gets in the way: the screen
// is about that one record, not about switching sections. A tab calls
// setChromeHidden(true) while it's in that state and false on the way out.
//
// Its own file rather than living in ManageTOSP, which imports every tab —
// a tab importing back from there would be a cycle.
export interface TospChrome {
  setChromeHidden: (hidden: boolean) => void;
  /**
   * A record the tab should open on, set by whatever sent the admin there.
   *
   * Used by the traffic lights' Go: for a task whose answer is a decision rather
   * than a form, arriving on the right tab is not enough — the admin would have
   * to find the row that raised it. The tab reads this and reopens the question.
   *
   * Carried here rather than passed as a prop because the tab registry in
   * ManageTOSP renders each panel as a bare component with no props, and giving
   * one tab an argument would mean giving all of them one.
   */
  focus: string | null;
  /** Called by the tab once it has acted on `focus`, so it fires once. */
  clearFocus: () => void;
}

const TospChromeContext = createContext<TospChrome>({
  setChromeHidden: () => {},
  focus: null,
  clearFocus: () => {},
});

export const TospChromeProvider = TospChromeContext.Provider;

export const useTospChrome = (): TospChrome => useContext(TospChromeContext);
